import React from 'react';

class SearchField extends React.Component {
  constructor(props) {
    super(props)
    this.searchTimer = null
    this.handleChange = this.handleChange.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }
  handleChange(e){
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.props.onChange(e.target.value)
    }, 500);
  }

  handleKeyDown(event) {
    if (event.key === 'Enter') {
      clearTimeout(this.searchTimer);
      this.props.onChange(event.target.value)
    }
  }

  render() {
    return (
      <div className="cs-search-bar">
        <div className="cs-search-bar__input">
          <input
            type="text"
            disabled={this.props.isBusy}
            name="cs-s"
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            placeholder={this.props.placeholder}
          />
        </div>
        <button type="submit" alt="Search" value="Search">
          <img src="/wp-content/uploads/2020/04/search-icon.png" />
        </button>
      </div>
    )
  }
}

export default SearchField;
